module.exports = __webpack_public_path__ + "img/finland-respiratory-diseases-male.f68bea82.png";